import React from 'react';

interface RechnungPosition {
    id: number;
    description: string;
    pricePerItem: number;
    numberOfItems: number;
    tax: number;
}

interface PositionsSectionProps {
    positions: RechnungPosition[];
}

const PositionsSection: React.FC<PositionsSectionProps> = ({ positions }) => {
    const formatCurrency = (amount: number): string => {
        return new Intl.NumberFormat('de-DE', {
            style: 'currency',
            currency: 'EUR',
        }).format(amount / 100);
    };

    const calculatePositionTotal = (position: RechnungPosition): number => {
        return position.pricePerItem * position.numberOfItems;
    };

    const getTotalAmount = (): number => {
        return positions.reduce((sum, pos) => sum + calculatePositionTotal(pos), 0);
    };

    return (
        <div className="positions-section">
            <h2>Positionen</h2>
            {positions.length > 0 ? (
                <div className="positions-table-wrapper">
                    <table className="positions-table">
                        <thead>
                            <tr>
                                <th>Beschreibung</th>
                                <th>Preis pro Einheit</th>
                                <th>Anzahl</th>
                                <th>MwSt. (%)</th>
                                <th>Gesamt</th>
                            </tr>
                        </thead>
                        <tbody>
                            {positions.map((position) => (
                                <tr key={position.id}>
                                    <td>{position.description}</td>
                                    <td className="number-cell">{formatCurrency(position.pricePerItem)}</td>
                                    <td className="number-cell">{position.numberOfItems}</td>
                                    <td className="number-cell">{position.tax}%</td>
                                    <td className="number-cell amount-cell">
                                        {formatCurrency(calculatePositionTotal(position))}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                        <tfoot>
                            <tr className="total-row">
                                <td colSpan={4}><strong>Gesamt</strong></td>
                                <td className="number-cell amount-cell"><strong>{formatCurrency(getTotalAmount())}</strong></td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            ) : (
                <div className="no-positions">
                    <p>Keine Positionen vorhanden</p>
                </div>
            )}
        </div>
    );
};

export default PositionsSection;
